import { useEffect, useState } from 'react';

/**
 * Thin top-of-page scroll progress bar that scrubs against page scroll.
 * Inspired by ScrollTrigger.create({ scrub: true, onUpdate: ... }).
 */
export default function ScrollProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let rafId: number | null = null;

    const update = () => {
      const doc = document.documentElement;
      const total = (doc.scrollHeight - doc.clientHeight) || 1;
      const p = Math.min(1, Math.max(0, window.scrollY / total));
      setProgress(p);
      rafId = null;
    };

    const onScroll = () => {
      if (rafId == null) rafId = requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (rafId != null) cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <div
      aria-hidden
      className="fixed top-0 left-0 right-0 h-[2px] z-[100] pointer-events-none"
    >
      <div
        className="h-full bg-gradient-to-r from-primary-600 via-primary-500 to-accent-500 transition-[width] duration-75 ease-out"
        style={{ width: `${progress * 100}%` }}
      ></div>
    </div>
  );
}